import { CategoriesListCSSStyleImpl } from './categorieslistcss';
import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { CategoriesListViewImpl } from './categorieslistview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { CategoriesListAPIModelImpl, CategoriesListAPIModel } from './categoriesapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';



export interface CategoriesListComponentProps extends CRBTUIComponentProps
{
   categoryName: string;
}

export interface CategoriesListComponentState extends UIComponentState
{
  
    isDataNotLoaded: boolean;
}

export interface CategoriesListComponentHandler extends UIComponentHandler
{
    onDataNotLoaded(isNotLoaded: boolean): void;
    loadMore(categoryId: number, title: string, startIndex: number, offset: number): void;
}

export class CategoriesListComponent extends CRBTUIComponent<CategoriesListComponentProps, CategoriesListComponentState>
    implements CategoriesListComponentHandler
{
    private count: number;
    private isLoadMore: boolean = false;

    constructor(props: CategoriesListComponentProps)
    {
        super(props);
        this.state = {isDataNotLoaded:false};
    }

    onDataNotLoaded(isNotLoaded: boolean): void {
        this.setState({isDataNotLoaded: isNotLoaded});
      }
     componentDidMount()
    {
        (this.getView() as CategoriesListViewImpl).showLoader();
        this.getAPIModel().getCategories(this.props.categoryName);
    }
    updateCount(count: number)
    {
        this.count = count;

        (this.getView() as  CategoriesListViewImpl).removeAllTabs();
    }

  
    componentWillReceiveProps(nextProps: CategoriesListComponentProps)
    {   
        this.isLoadMore = false;
        (this.getView() as CategoriesListViewImpl).showLoader();
        (this.getView() as  CategoriesListViewImpl).updateTabData(0, this.props.context, 
        "", []);
        this.setState({isDataNotLoaded: false});
        this.getAPIModel().getCategories(nextProps.categoryName);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CategoriesListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CategoriesListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new CategoriesListAPIModelImpl(applicationContext, apiModelHandler);
    }

    getAPIModel(): CategoriesListAPIModel
    {
        return (super.getAPIModel() as CategoriesListAPIModel);
    }

    loadMore(categoryId: number, title: string, startIndex: number, offset: number): void 
    {
        this.isLoadMore = true;
        (this.getView() as CategoriesListViewImpl).showLoader();
        this.getAPIModel().getLoadMoreFeatureCategoriesTones(categoryId, title, startIndex, offset);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        
        if(!this.isLoadMore)
        {
            this.count--;

            (this.getView() as  CategoriesListViewImpl).updateTabData((data as FeaturedCategoryDto).getCategoryId(),
            this.props.context, (data as FeaturedCategoryDto).getTitle(), (data as FeaturedCategoryDto).getListOfTones());
            if(this.count === 0)
            {
                (this.getView() as CategoriesListViewImpl).dismissLoader();
                (this.getView() as  CategoriesListViewImpl).updateTab();
            }
        }
        else
        {
            (this.getView() as CategoriesListViewImpl).dismissLoader();

            (this.getView() as  CategoriesListViewImpl).updateLoadMoreTabData(
                (data as FeaturedCategoryDto).getTitle(), (data as FeaturedCategoryDto).getListOfTones());
            this.setState({ isDataNotLoaded: (data as FeaturedCategoryDto).getListOfTones().length > 0 ? false : true});
        }

        window.scroll(0, 0);
    }

    onFailure(feature: APIFeatures, description: string, data: any)
    {
        
        console.log("failure");
        if(feature === APIFeatures.CATEGORIES)
        {
            
            (this.getView() as CategoriesListViewImpl).dismissLoader();
            this.setState({ isDataNotLoaded: true});
        }
        else
        {
            if(!this.isLoadMore)
            {
                this.count --;
                if(this.count === 0 && (this.getView() as  CategoriesListViewImpl).getListOfTitles().length === 0 )
                {
                
                    (this.getView() as CategoriesListViewImpl).dismissLoader();
                
                    this.setState({ isDataNotLoaded: true});
                }
            }
            else
            {
                (this.getView() as CategoriesListViewImpl).dismissLoader();
            }
        }

        window.scroll(0, 0);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categorieslist/categorieslistcomponent.tsx